import { useEffect, useState } from "react";
import { useImageStore } from "./helpers/state";
import uploadicon from "../asset/upload_icon.png";
import { validateFile, validationConfigs } from "./helpers/fileValidation";
import Swal from "sweetalert2";

const Uploads = () => {
  const [hide, setHide] = useState(false);
  const [show, setShow] = useState(true);
  const [block, setBlock] = useState("block");
  const [unblock, setUnblock] = useState();

  const selectedImage = useImageStore((state) => state.selectedImage);
  const setSelectedImage = useImageStore((state) => state.setSelectedImage);
  const removeSelectedImage = useImageStore(
    (state) => state.removeSelectedImage
  );

  useEffect(() => {
    if (selectedImage === null) {
      setHide(false);
      setShow(true);
    } else if (selectedImage !== "") {
      setHide(true);
      setBlock();
      setShow(false);
      setUnblock("block");
    }
  }, [selectedImage]);

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      // Validate file using imagesOnly config
      const validation = validateFile(file, validationConfigs.imagesOnly);
      if (!validation.valid) {
        Swal.fire({
          icon: "error",
          title: "Jenis Fail Tidak Sah",
          text: validation.message,
        });
        e.target.value = ""; // Clear the input
        return;
      }

      setSelectedImage(file);
    }
  };

  const changeImage = () => {
    document.getElementById("passport").click();
  };

  return (
    <>
      <div className="">
        <label
          hidden={hide}
          className={`${block} text-lime-600 font-bold w-full h-40 border-2 rounded-md text-center  mt-1 cursor-pointer`}
        >
          <div className="bg-gray-200 rounded-full w-9 h-9 m-auto mb-1">
            <img
              src={uploadicon}
              alt={"Upload"}
              className="w-7 h-7 ml-1 pt-1 my-5 "
              accept="image/png, image/jpeg, image/jpg"
            />
          </div>
          Klik untuk muat naik
          <br />
          <label className="text-sm text-gray-500">
            JPG, JPEG or PNG (max. 800x400px)
            JPG, JPEG or PNG (max. 800x400px)
          </label>
          <input
            id="passport"
            className="w-full h-32"
            accept="image/jpeg, image/jpg, image/png"
            name="gambar"
            type="file"
            hidden={true}
            onChange={imageChange}
          />
        </label>

        {selectedImage && (
          <div className="w-full h-48 ">
            <img
              className=" w-full h-full object-contain border-2"
              src={URL.createObjectURL(selectedImage)}
              alt="gambar profile"
            />
            <input type={"button"} onClick={removeSelectedImage} />
          </div>
        )}
        <label
          hidden={show}
          onClick={changeImage}
          className={` ${unblock} h-10 w-full border-2 rounded-md  text-center pt-1 cursor-pointer bg-gray-50 mt-5`}
        >
          Tukar gambar
        </label>
      </div>
    </>
  );
};

export default Uploads;
